export const NOTIFICATION_DATA = 'notification/data'
